export const TaurusIcon = ({ strokeWidth = 1, className = "size-5", ...props }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor" 
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path 
        d="M20.7 15.0594V6.63937C20.7 6.49937 20.61 6.37937 20.48 6.33937C20.35 6.29937 20.21 6.33937 20.13 6.45937C17.75 9.77937 13.67 8.48937 9.71995 7.24937C7.75995 6.62937 5.90995 6.04937 4.27995 6.00937C2.37995 5.96937 1.05995 6.69937 0.239951 8.24937C0.219951 8.29937 0.199951 8.34937 0.199951 8.39937V17.2194C0.199951 17.3494 0.279951 17.4694 0.399951 17.5094C0.519951 17.5594 0.659951 17.5194 0.749951 17.4294C1.73995 16.3394 3.23995 15.8494 5.33995 15.9294C7.24995 15.9994 9.37995 16.5194 11.45 17.0194C13.49 17.5094 15.46 17.9894 17.08 17.9894C18.67 17.9894 19.91 17.5294 20.5 16.1494C20.52 16.0994 20.54 16.0394 20.57 15.9794C20.68 15.6994 20.69 15.3894 20.7 15.1794C20.7 15.1794 20.7 15.0694 20.7 15.0594ZM20.38 15.1594C20.38 15.2494 20.38 15.5894 20.27 15.8694C20.25 15.9194 20.23 15.9794 20.21 16.0294C17.98 21.1894 5.13995 12.1294 0.509951 17.2194V8.38937C3.96995 1.86937 15.48 13.4794 20.38 6.63937V15.0594C20.38 15.0594 20.38 15.1394 20.38 15.1594Z" 
        fill="currentColor" 
        stroke="currentColor" 
        strokeWidth="0.4" 
        strokeLinejoin="round"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M0.52002 13.2601C2.81002 8.44008 17.23 15.5001 20.39 10.5801V13.0701C14.52 16.0901 2.74002 8.54008 0.52002 14.1101V13.2601Z" 
        fill="currentColor"
      />
    </svg>
  );
};